/* eslint-disable eqeqeq */
<template>
  <div class="sellertip">
    <Stance type="general" :btn-text="btnText" :show-info="false" :descText="msg" @click="closePage" :show-btn="true"/>
    <div class="skipContainer" v-show="skip!=='-1'"><span @click="handleSkip" class="skipBtn">订单实际为快递交易怎么办？</span></div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Stance } from '@zz-common/zz-ui'
import { getmsgbytype } from '@api/resourceApi'
import { toast } from '../../../native'
import { queryParams } from '../../../lib/utils'
const query = queryParams()

export default {
  name: 'SellerTip',
  data() {
    return {
      channel: native.client,
      type: query.type || this.$route.query.type,
      source: query.source || this.$route.query.source,
      infoId: query.infoId || this.$route.query.infoId,
      insert: query.insert || this.$route.query.insert,
      skip: '-1',
      skipUrl: '/cloudInspection/examineInfo',
      msg:
          '抱歉您暂时无法申请解冻，请联系买家在订单详情页面申请解冻，买家申请并上传在线验货信息，后台24小时内审核通过后钱款会打给您的账户。如买家未进行申请，您的钱款将在冻结之日起第7天到账。'
    }
  },
  computed: {
    btnText() {
      // eslint-disable-next-line eqeqeq
      return this.channel === 'zz' && this.type == 1 ? '去联系买家' : '返回'
    }
  },
  components: {
    Stance
  },
  methods: {
    closePage() {
      // eslint-disable-next-line eqeqeq
      if (this.type == 1) {
        if (this.channel === 'zz') {
          return native.wrap('enterUnifiedUrl')({
            unifiedUrl: 'zhuanzhuan://jump/core/mainPage/jump?tabId=2',
            needClose: '1'
          })
        }
        if (this.channel === 'zzseller') {
          return native.wrap('enterUnifiedUrl')({
            unifiedUrl: 'zhuanzhuanseller://jump/core/mainPage/jump?tabId=2',
            needClose: '1'
          })
        }
      }
      native.close()
    },
    handleSkip() {
      native.skipToUrl({
        targetUrl: `https://feentry.zhuanzhuan.com/spam_cloudInspection?clientid=CloudInspectionPushSubmit&source=${this.source}&infoId=${this.infoId}&insert=${this.insert}`,
        needClose: '1'
      });
    },
    init() {
      this.getMsgByBype()
    },
    getMsgByBype() {
      return getmsgbytype({
        type: this.type
      })
        .then((respData) => {
          console.log('---respData', respData)
          const { msg = '', title = '', skip = '' } = respData
          this.msg = msg || ''
          this.skip = skip
          native.setTitle({
            title
          })
          console.log('---this.msg', this.msg)
          return respData
        })
        .catch((err) => {
          console.error(err)
          if (!err.errMsg) return
          toast({
            msg: err.errMsg,
            style: '2'
          })
        })
    }
  },
  mounted() {
    // native.setTitle({
    //   // eslint-disable-next-line eqeqeq
    //   title: ''
    // });
    this.init()
    console.log('native.client', native.client)
  },
  beforeRouteEnter(_to, _from, next) {
    next((_vm) => {
      native.wrap('resetRightAllButton')()
    })
  }
}
</script>

<style lang="less">
  @import 'index.less';
</style>
